import { render } from "./ArrowUp.vue?vue&type=template&id=ab336bc0&scoped=true"
const script = {}

import "./ArrowUp.vue?vue&type=style&index=0&id=ab336bc0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab336bc0"]])

export default __exports__